import React, { PureComponent, useState } from "react";
import { Chart } from "react-google-charts";
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import axios from "axios";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import { getRequest, putRequest } from "../../services/ApiServices";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
// export const data = [
//     ["Users", "State"],
//     ["Registered Users", 200],
//     ["Inactive Users", 300],
//     ["Online", 15],

// ];


const useStyles = makeStyles((theme) => ({
    tableBody:{
        "& .tss-10rusft-MUIDataTableToolbar-icon":{
          color:"#ff4717",
          boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
          marginLeft:"15px"
          
        },
        "& .tss-9z1tfs-MUIDataTableToolbar-iconActive":{
            color:"#ff4717",
            boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
            marginLeft:"15px"
          },
        "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
          justifyContent:"left",
           position:"absolute",
          
            },
            "& .tss-1ufdzki-MUIDataTableSearch-main":{
                marginRight:"10px",
                width:500
              },
              "& .tss-1fz5efq-MUIDataTableToolbar-left ":{
               position: "absolute",
               right:25
              }
      }
})) 

export default function UsersChart(props) {
    // const { chartData } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [UserDetails, setUserDetails] = React.useState();
    const[User,SetUser]=React.useState([]);

    const getMuiTheme = () => createTheme({

        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    textTransform: "none"
                }
            }
        }
    })
    let { title, chartType, datatype, chartData } = props;
    if (chartData) {
        let options = {
            title: `Total Users : ${chartData.allUsers}`,
            colors:  ['#0041C2','#e0440e','#ff8000', ] ,
            pieSliceText: "label",
            is3D: true,
            //curveType: "function",
            legend: { position: "bottom" },
            enableInteractivity: true,
            //tooltip: { isHtml: true, trigger: "selection" }
        };
        let data = [["Users", "State"]]
        data.push(["Registered Users", chartData.activeUsers]);
        data.push(["Active Users", chartData.loggedUsers]);
        data.push(["Inactive Users", chartData.inActiveUsers]);
        

        const columns = [
            {
                name: "username",
                label: "User Name",
                options: {
                    filter: true,
                    sort: true,

                }
            }];
    
        
    const optionss = {
            customToolbarSelect:()=>{
                <>
                onRowsDelete:True,
                </>
                
              },
            
              selectToolbarPlacement:"above",
              selectableRows:"multiple",
            responsive: 'standard',
            filterType: "dropdown",
            rowsPerPageOptions: [10, 15, 50, 100],
            textLabels: 'label',
            downloadOptions:{
                filterOptions:{
                  useDisplayedColumnsOnly:true,
                  useDisplayedRowsOnly:true
                }
               },
               onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
                let isExist=[];
                rowsSelected.forEach((d)=>{
                isExist.push(UserDetails[d]);
              })
            
             SetUser(isExist)
            },
            
              onDownload:(buildHead, buildBody,columns, gridData)=>{
                
                var myData= [];
                // var newKeys = Object.keys(loginfailedtable[0]);
                var idx = 0;
                var columnsExport = [];
                var columnsExport1 = [];
                columnsExport.push("");
                columns.forEach((cl) => {
                  //if(cl.label!=="Customer Contract")
                  columnsExport.push(cl.label);
            
                })
                // newKeys.forEach((k) => {
                //   columnsExport.push(k);
                // });
                columnsExport.push("\n");
               let i = 0;
               
                //console.log(item);
                UserDetails.length>0?
                (
                  User.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.username && dfdt[1] == item.timestamp)
                    return true;
                  else
                    return false;
            
                });
               if (visibleRows.length > 0) {
                
                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;
               
                let objsample={
                username:itemData.username,
                }
               
                  let data = [];
                  data.push(...Object.values({ ...objsample}));
                  data.push("\n");
                  dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
               }
            })
                ):(
                
                    UserDetails.forEach((item) => {
                    debugger
                  let visibleRows = gridData.filter((df) => {
                    let dfdt = df.data;
                    if (dfdt[0] == item.username && dfdt[1] == item.timestamp)
                      return true;
                    else
                      return false;
              
                  });
                 if (visibleRows.length > 0) {
                  
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++; 
                  itemData.customername = itemData.customername.replace(/,/g, "");
                  
              let objsample={
                    username:itemData.username,
                    
                   }
                 
                    let data = [];
                    data.push(...Object.values({ ...objsample}));
                    data.push("\n");
                    dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                  // console.log("myData",myData)
                 }
                })
                )
            buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
            }
            buildBody = () => {
            // console.log(myData);
            return  myData;
            }
            return buildHead() + buildBody();
              }
        };
        const handleClose = () => {
            setOpen(false);
        };
        return (
            <>
                <Dialog
                    fullWidth={fullWidth}
                    maxWidth="xl"
                    open={open}
                    onClose={handleClose}
                >
                    <DialogActions>
                        <Button onClick={handleClose}><CancelIcon /></Button>
                    </DialogActions>

                    <DialogContent>
                        <ThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                title={"User List"}
                                data={UserDetails}
                                columns={columns}
                               className={classes.tableBody}
                                options={optionss}
                            />
                        </ThemeProvider>
                        {/* {!chartDetails.datatype?  (<UsersChart title="Users By Chart" ></UsersChart>):(<UsersByChart title={chartDetails.title} datatype={chartDetails.datatype} ></UsersByChart>)} */}
                    </DialogContent>

                </Dialog>
                <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width={"100%"}
                    height={"400px"}
                    //   chartEvents={[
                    //     {
                    //         eventName: "select",
                    //         callback: ({ chartWrapper, google }) => {
                    //             var selection = chartWrapper.getChart().setAction({
                    //                 id: "alertAction",
                    //                 text: "Click Me!",
                    //                 action: function () {
                    //                     //alert("Stay away Corona Virus!!");
                    //                     setOpen(true);
                    //                 }
                    //             });
                    //             console.warn(selection);
                    //         }
                    //     }
                    // ]}
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                const chart = chartWrapper.getChart();

                                var handler = function (e) {
                                    //console.log(e);
                                    //
                                    var parts = e.targetID.split("#");
                                    let users = "";
                                    let datatypes = "";
                                    if (parts.indexOf("legendentry") >= 0) {
                                        let idx = parts[parts.indexOf("legendentry") + 1];
                                        idx = parseInt(idx)
                                        if (Object.keys(chartData)[0] == 'allUsers') {
                                            users = 'allUsers'
                                        } else if (Object.keys(chartData)[1] == "loggedUsers") {
                                            users = 'loggedUsers'
                                        } else if (Object.keys(chartData)[2] == "activeUsers") {
                                            users = 'activeUsers'
                                        } else if (Object.keys(chartData)[3] == "inActiveUsers") {
                                            users = 'inActiveUsers'
                                        }

                                        datatypes = datatype;
                                        setOpen(true);
                                    }
                                    if (datatypes != "" && users != "") {
                                        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserdetails/${datatypes}/${users}`;
                                        getRequest(url)
                                            .then((res) => {
                                                if (res.data) {
                                                    //dispatch({ type: LOADING, payload: false });
                                                    console.log(res.data);
                                                    setUserDetails(res.data);


                                                } else {
                                                    dispatch({ type: LOADING, payload: false });
                                                    ToastError(res.data.message);
                                                }
                                            })
                                            .catch((error) => {
                                                dispatch({ type: LOADING, payload: false });
                                            });
                                    }
                                };

                                google.visualization.events.addListener(
                                    chartWrapper.getChart(),
                                    "click",
                                    handler
                                );
                                //setOpen(true);
                            }
                        }
                    ]}
                />
            </>
        );
    }
    else {
        return (<></>)
    }
}